import { APIMethod, fetchData } from "@client";

export async function setNotificationReadQuery(notificationId) {
  return await fetchData("/user/notifications", APIMethod.PUT, {
    data: {
      id: notificationId
    }
  });
}
